module.exports = __webpack_public_path__ + "assets/img/1991.png?ebfbfe68b1bfb0536c6f27ee89429cbf";